const RECIPE_UPLOAD_REQUEST = 'RECIPE_UPLOAD_REQUEST';
const RECIPE_UPLOAD_SUCCESS = 'RECIPE_UPLOAD_SUCCESS';
const RECIPE_UPLOAD_FAIL = 'RECIPE_UPLOAD_FAIL';

const RECIPE_EDIT_REQUEST = 'RECIPE_EDIT_REQUEST';
const RECIPE_EDIT_SUCCESS = 'RECIPE_EDIT_SUCCESS';
const RECIPE_EDIT_FAIL = 'RECIPE_EDIT_FAIL';

const RECIPE_DELETE_REQUEST = 'RECIPE_DELETE_REQUEST';
const RECIPE_DELETE_SUCCESS = 'RECIPE_DELETE_SUCCESS';
const RECIPE_DELETE_FAIL = 'RECIPE_DELETE_FAIL';

export {
  RECIPE_UPLOAD_REQUEST,
  RECIPE_UPLOAD_SUCCESS,
  RECIPE_UPLOAD_FAIL,
  RECIPE_EDIT_REQUEST,
  RECIPE_EDIT_SUCCESS,
  RECIPE_EDIT_FAIL,
  RECIPE_DELETE_REQUEST,
  RECIPE_DELETE_SUCCESS,
  RECIPE_DELETE_FAIL
};